import { createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';
import { lt } from '@mews/framework';
import { TrialBalanceDate } from '../components/TrialBalanceDate';
import { TrialBalanceRowActions } from '../components/TrialBalanceRowActions';
import { TrialBalanceTableRow } from '../types';

const columnHelper = createColumnHelper<TrialBalanceTableRow>();
export const useTableMapping = () =>
    useMemo(
        () => [
            columnHelper.accessor('date', {
                enableSorting: true,
                header: () => lt('EndOfDayDate'),
                cell: (cell) => <TrialBalanceDate date={cell.getValue()} />,
            }),
            columnHelper.display({
                id: 'actions',
                header: () => lt('Downloads'),
                cell: (cell) => <TrialBalanceRowActions dateISOstring={cell.row.original.dateISOString} />,
                meta: {
                    width: '20%',
                },
            }),
        ],
        []
    );
